import { useQuery } from '../../../../ReactQuery';
import { get } from '../../../../redux/api';
import type { ListMethodsResponse } from '../../../../../shared/types/routes/auth/mfa';

export const getMfaMethodsQueryKey = () => ['mfa-methods'];

function fetchMfaMethods() {
  return get<ListMethodsResponse>('/api/auth/mfa/methods');
}

/**
 * Fetch the user's configured MFA methods
 */
export default function useListMfaMethods() {
  return useQuery<ListMethodsResponse>({
    queryKey: getMfaMethodsQueryKey(),
    queryFn: fetchMfaMethods,
  });
}
